<template>
  <div class="text-salesflow-font-dark lead-owner">
    <InputEditable
      type="select"
      :options="getUsers()"
      field="single_owner"
      :value="owner"
      placeholder="Selecione"
      @update="update"
      title="Dono do Lead"
      :url="'/lead/' + lead.hashid"
      :custom-class="customClass"
      :display-text="owner"
    />
  </div>
</template>

<script>
export default {
  props: {
    lead: {
      required: true,
      type: Object,
    },
    customClass: '',
  },

  store: ['users'],

  data () {
    return {
      owner: this.lead.owner.name || 'Selecione',
    };
  },

  methods: {
    getUsers () {
      return this.users.map((user) => ({ value: user.id, text: user.first_name }));
    },

    update (user_id) {
      const user = this.users.find((user) => user.id == user_id);

      this.owner = user.first_name;
    },
  },
};
</script>
